import React, { ReactNode } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useTenant } from "../../contexts/TenantContext";
import { useTheme } from "../../contexts/ThemeContext";
import Navigation from "./Navigation";
import LoadingSpinner from "./LoadingSpinner";

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const { state } = useAuth();
  const { customization } = useTenant();
  const { isDark } = useTheme();

  // Only apply background in light mode and only if company has custom background
  const backgroundStyle = !isDark && customization.backgroundUrl
    ? {
        backgroundImage: `url(${customization.backgroundUrl})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }
    : {};

  if (state.isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!state.isAuthenticated) {
    return <>{children}</>;
  }

  return (
    <div
      className="min-h-screen bg-gray-50 dark:bg-gray-900"
      style={backgroundStyle}
    >
      <Navigation />
      <main className="py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">{children}</div>
      </main>
    </div>
  );
}
